import * as types from 'ducks/types'
import {
    ImageShapeType,
    OverlayShapeType,
    QuickGuiddeType,
    RectangleShapeType,
    CircleWithTextShapeType,
    QuickGuiddeLayerType,
    SpeechToTextType,
    TextToSpeechType,
    arrowDirectionType
} from 'app/types'

export const setQuickGuiddeDuration = (payload: { duration: number; applyToAll: boolean }) =>
    ({
        type: types.SET_QUICK_GUIDDE_DURATION,
        payload
    } as const)

export const setArrowDirection = (payload: arrowDirectionType) =>
    ({
        type: types.SET_ARROW_DIRECTION,
        payload
    } as const)

export const setQuickGuiddeSteps = (payload: { steps: Array<QuickGuiddeType> }) =>
    ({
        type: types.SET_QUICK_GUIDDE_STEPS,
        payload
    } as const)

export const setSidePanelMode = (payload: 'metadata' | 'voiceOver') =>
    ({
        type: types.SET_SIDE_PANEL_MODE,
        payload
    } as const)

export const setActiveStep = (payload: number) =>
    ({
        type: types.SET_ACTIVE_STEP,
        payload
    } as const)

export const setLayerPosition = (payload: { idx: number; x: number; y: number }) =>
    ({
        type: types.SET_LAYER_POSITION,
        payload
    } as const)

export const setLayerTransform = (payload: {
    idx: number
    x: number
    y: number
    width?: number
    height?: number
    scaleX?: number
    scaleY?: number
    rotation?: number
    radius?: number
    fontSize?: number
}) =>
    ({
        type: types.SET_LAYER_TRANSFORM,
        payload
    } as const)

export const setLayerText = (payload: { layerId: string; title: string; height?: number }) =>
    ({
        type: types.SET_LAYER_TEXT,
        payload
    } as const)

export const toggleSpotlight = () =>
    ({
        type: types.TOGGLE_SPOTLIGHT
    } as const)

export const addBackgroundLayer = (payload: ImageShapeType | RectangleShapeType) =>
    ({ type: types.ADD_BACKGROUND_LAYER, payload } as const)

export const setBackgroundImage = (payload: ImageShapeType) =>
    ({ type: types.SET_BACKGROUND_IMAGE, payload } as const)

export const setBackgroundColor = (
    payload:
        | {
              fill: string
              fillLinearGradientColorStops: undefined
              fillLinearGradientStartPoint: undefined
              fillLinearGradientEndPoint: undefined
          }
        | {
              fill: undefined
              fillLinearGradientColorStops?: Array<string | number>
              fillLinearGradientStartPoint?: Record<'x' | 'y', number>
              fillLinearGradientEndPoint?: Record<'x' | 'y', number>
          }
) => ({ type: types.SET_BACKGROUND_COLOR, payload } as const)

export const addOverlayLayer = (payload: OverlayShapeType) =>
    ({ type: types.ADD_OVERLAY_LAYER, payload } as const)

export const addNewLayer = (payload: QuickGuiddeLayerType) =>
    ({ type: types.ADD_NEW_LAYER, payload } as const)

export const setFontSize = (payload: number) => ({ type: types.SET_FONT_SIZE, payload } as const)

export const setTextHeight = (payload: { id: string; height: number }) =>
    ({ type: types.SET_TEXT_HEIGHT, payload } as const)

export const setTextColors = (payload: { color?: string; backgroundColor?: string }) =>
    ({ type: types.SET_TEXT_COLORS, payload } as const)

export const addStepNumbering = (payload: CircleWithTextShapeType) =>
    ({ type: types.ADD_STEP_NUMBERING, payload } as const)

export const setStepNumberingText = (payload: { index: number; title: string }) =>
    ({
        type: types.SET_STEP_NUMBERING_TEXT,
        payload
    } as const)

export const removeStepNumbering = () => ({ type: types.REMOVE_STEP_NUMBERING } as const)

export const copySelectedLayer = () => ({ type: types.COPY_SELECTED_LAYER } as const)

export const moveSelectedLayer = (payload: { direction: 'TOP' | 'RIGHT' | 'BOTTOM' | 'LEFT' }) =>
    ({ type: types.MOVE_SELECTED_LAYER, payload } as const)

export const pasteSelectedLayer = () => ({ type: types.PASTE_SELECTED_LAYER } as const)

export const duplicateSelectedLayer = () => ({ type: types.DUPLICATE_SELECTED_LAYER } as const)

export const removeSelectedLayer = () => ({ type: types.REMOVE_SELECTED_LAYER } as const)

export const setStep = (payload: QuickGuiddeType) =>
    ({
        type: types.SET_STEP,
        payload
    } as const)

export const addCoverStep = (payload: QuickGuiddeType) =>
    ({
        type: types.ADD_COVER_STEP,
        payload
    } as const)

export const addEndingStep = (payload: QuickGuiddeType) =>
    ({
        type: types.ADD_ENDING_STEP,
        payload
    } as const)

export const addNewStep = (payload: QuickGuiddeType) =>
    ({
        type: types.ADD_NEW_STEP,
        payload
    } as const)

export const duplicateActiveStep = () =>
    ({
        type: types.DUPLICATE_ACTIVE_STEP
    } as const)

export const removeActiveStep = () =>
    ({
        type: types.REMOVE_ACTIVE_STEP
    } as const)

export const selectLayer = (payload: string | null) =>
    ({
        type: types.SELECT_LAYER,
        payload
    } as const)

export const enableShortcuts = () =>
    ({
        type: types.ENABLE_QG_SHORTCUTS
    } as const)

export const disableShortcuts = () =>
    ({
        type: types.DISABLE_QG_SHORTCUTS
    } as const)

export const setTempAudioNote = (payload?: QuickGuiddeType['tempAudioNote']) =>
    ({
        type: types.SET_TEMP_QUICK_GUIDDE_AUDIO_NOTE,
        payload
    } as const)

export const setAudioNote = (payload?: SpeechToTextType | TextToSpeechType) =>
    ({
        type: types.SET_QUICK_GUIDDE_AUDIO_NOTE,
        payload
    } as const)

export const resetSteps = () =>
    ({
        type: types.RESET_STEPS
    } as const)

export const setDndAreaVisibility = (payload: boolean) =>
    ({
        type: types.SET_DND_AREA_VISIBILITY,
        payload
    } as const)

export const setStepLayer = (payload: { layerId: string; layer: ImageShapeType }) =>
    ({
        type: types.SET_QUICK_GUIDDE_STEP_LAYER,
        payload
    } as const)
